export default __webpack_public_path__ + "static/media/discount33.f6e751e2.png";